import React, { ReactElement, ReactNode } from 'react';
import RouterLink from '@/shared/ui/UtmLink';

type Props = {
    to : string;
    className ?: string;
    children : ReactNode;
    target ?: string;
    [key : string] : any;
};

const Link : React.FC<Props> = ({
    to, className = '', children, target, ...props
}) : ReactElement => {
    if (to.includes('.php')) {
        return (
            <a href={to} target={target} className={`text-[1.125rem] leading-[24px] duration-200 hover:text-[#7041AC] font-semibold ${className}`} {...props}>{children}</a>
        );
    }

    return (
        <RouterLink
            href={to}
            className={`text-[1.125rem] leading-[24px] duration-200 hover:text-[#7041AC] font-semibold ${className}`}
            target={target}
            {...props}
        >
            {children}
        </RouterLink>
    );
};

export default Link;
